import { render, staticRenderFns } from "./Substructure.vue?vue&type=template&id=6ef0acde&scoped=true"
import script from "./Substructure.vue?vue&type=script&lang=js"
export * from "./Substructure.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ef0acde",
  null
  
)

export default component.exports